import { useEffect } from 'react'

import {
  EAgentKeys,
  EChatStatus,
  TChatSettings,
} from '~/features/agents/models'
import { getAgentChatSettings } from '~/features/agents/utils'
import {
  DEFAULT_POPUP_DELAY,
  DEFAULT_POPUP_MESSAGE,
} from '~/features/chatbot/constants'
import useIsEmbeddedChat from '~/features/chatbot/hooks/useIsEmbeddedChat'
import { sendLoadPopup } from '~/features/chatbot/utils'
import { store } from '~/store'

type TProps = {
  isLoading: boolean
}

const useEmbeddedPopup = ({ isLoading }: TProps) => {
  const { isEmbedded } = useIsEmbeddedChat()
  const chatbot = store((state) => state.chatbot)

  useEffect(() => {
    if (isLoading) return

    if (chatbot.agent.chatStatus === EChatStatus.active && isEmbedded) {
      const chatSettings =
        getAgentChatSettings(chatbot.agent[EAgentKeys.chatSettings]) ||
        ({} as TChatSettings)

      const {
        embedPopupAutoCloseDelaySeconds,
        embedPopupAutoCloseEnabled,
        embedPopupCustomImageUrl,
        embedPopupDelaySeconds,
        embedPopupDevices,
        embedPopupEnabled,
        embedPopupMessage,
      } = chatSettings

      if (embedPopupEnabled) {
        sendLoadPopup({
          autoClosePopupDelay:
            embedPopupAutoCloseEnabled && !!embedPopupAutoCloseDelaySeconds
              ? embedPopupAutoCloseDelaySeconds
              : undefined,
          customIconUrl: embedPopupCustomImageUrl || '',
          openPopupDelay:
            typeof embedPopupDelaySeconds === 'number' &&
            embedPopupDelaySeconds >= 0
              ? embedPopupDelaySeconds
              : DEFAULT_POPUP_DELAY,
          popupDevices: embedPopupDevices || [],
          popupMessage: embedPopupMessage || DEFAULT_POPUP_MESSAGE,
        })
      }
    }
  }, [chatbot, isEmbedded, isLoading])
}

export default useEmbeddedPopup
